import { toast } from 'react-hot-toast';

const showToast = (type, message) => {
    const isSuccess = type === 'success';

    toast.custom(
        (t) => (
            <div
                className={`flex items-center gap-3 min-w-[300px] px-4 py-3 rounded-xl shadow-lg ${
                    isSuccess ? 'bg-slate-900' : 'bg-slate-900'
                }`}
            >
                <span className="text-lg">
                    {isSuccess ? '✅' : '❌'}
                </span>

                <span className="flex-1 text-sm font-medium text-white">
                    {message}
                </span>

                <button
                    type="button"
                    onClick={() => toast.dismiss(t.id)}
                    className="text-gray-400 hover:text-white text-lg font-bold"
                >
                    ×
                </button>
            </div>
        ),
        {
            duration: isSuccess ? 3000 : 5000,
        }
    );
};

export default showToast;